import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "block"]

  addFields(event) {
    event.preventDefault()
    const blocks = this.blockTargets
    if (blocks.length === 0) return

    const lastBlock = blocks[blocks.length - 1]
    const oldIndex = lastBlock.dataset.index
    const newIndex = new Date().getTime().toString()

    const clone = lastBlock.cloneNode(true)
    clone.dataset.index = newIndex

    clone.querySelectorAll("[name]").forEach((el) => {
      const name = el.getAttribute("name")
      if (name && name.includes("[section_ctas_attributes]")) {
        el.setAttribute("name", name.replace(new RegExp(`\\]${escapeRegExp(oldIndex)}\\[`), `]${newIndex}[`))
      }
    })

    const indexReplacement = (str) =>
      str.replace(`section_ctas_attributes_${oldIndex}`, `section_ctas_attributes_${newIndex}`)

    clone.querySelectorAll("[id]").forEach((el) => {
      const id = el.getAttribute("id")
      if (id && id.includes("section_ctas_attributes")) {
        el.setAttribute("id", indexReplacement(id))
      }
    })

    clone.querySelectorAll("[for]").forEach((el) => {
      const f = el.getAttribute("for")
      if (f && f.includes("section_ctas_attributes")) {
        el.setAttribute("for", indexReplacement(f))
      }
    })

    clone.querySelectorAll("input:not([type=hidden]), textarea, select").forEach((el) => {
      if (el.name?.includes("_destroy")) {
        el.checked = false
      } else {
        el.value = ""
      }
    })

    const blockNum = blocks.length + 1
    const heading = clone.querySelector("h4")
    if (heading) {
      heading.textContent = heading.textContent.replace(/\d+$/, blockNum)
    }

    this.containerTarget.appendChild(clone)
  }
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}
